<script setup lang="ts">
import type { SelectionVariant } from '@/composables/eos/activation-selection'

defineProps<{
  modelValue: boolean
  variant: SelectionVariant
  indeterminate?: boolean
  disabled?: boolean
}>()

defineEmits<{ change: [value: boolean] }>()
</script>

<template>
  <el-checkbox
    :class="`select-${variant}`"
    :model-value="modelValue"
    :indeterminate="indeterminate"
    :disabled="disabled"
    @change="(value) => $emit('change', Boolean(value))"
  />
</template>

<style scoped>
.select-active {
  --el-checkbox-checked-bg-color: #10b981;
  --el-checkbox-checked-input-border-color: #10b981;
  --el-checkbox-input-border-color-hover: #10b981;
}

.select-inactive {
  --el-checkbox-checked-bg-color: var(--el-color-warning);
  --el-checkbox-checked-input-border-color: var(--el-color-warning);
  --el-checkbox-input-border-color-hover: var(--el-color-warning);
}
</style>
